import LogoImage from '@assets/images/logo.svg'
import cn from 'classnames'
import type { ReactNode } from 'react'

import './CheckoutContainer.scss'

type CheckoutContainerProps = {
  className?: string
  children?: ReactNode
}

export const CheckoutContainer = ({ className, children }: CheckoutContainerProps) => (
  <div className={cn('checkout-container-wrapper', className)}>
    <div className='checkout-header'>
      <span>
        <img src={LogoImage} alt='Jetonbank logo' />
      </span>
    </div>

    {children}
  </div>
)
